"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M0 17c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V7H0v10zM19 4H9.41l-1.7-1.71A.997.997 0 007 2H1c-.55 0-1 .45-1 1v3h20V5c0-.55-.45-1-1-1z"];
//# sourceMappingURL=folder-close.js.map